/*
 * Company: WHIZ Ltd.
 * Project: TA
 * Module: WebApplication
 * Author: sales@whiz.bg
 */

/**
 * check the return value of an axios call and provide error message if appropriate
 * @param {*} status 
 * @param {*} language 
 * @returns 
 */
function getStatusMessage(status, language) {
    // message mapping
    const messages = {
        en: {
            9101: "Unrecognized action. (#9101)",
            9102: "Action not implemented. (#9102)",
            9103: "Command execution error. (#9103)",
            9104: "Unsupported software version. (#9104)",
            9105: "Request processing error. (#9105)",
            9106: "Market order must not include price. (#9106)",
            9201: "Communication between modules failed. (#9201)",
            9202: "Invalid query or DB response. (#9202)",
            9203: "Cannot add SSE event. (#9203)",
            9204: "Invalid date format. (#9204)",
            9205: "Notification failed via Google API. (#9205)",
            9206: "Invalid SSE parameter state. (#9206)",
            9207: "Local database error. (#9207)",
            9208: "Session expired. (#9208)",
            9209: "Key expired. (#9209)",
            9301: "Invalid username or password. Login failed. Please check your credentials. (#9301)",
            9302: "No such user. (#9302)",
            9303: "Password change failed. (#9303)",
            9304: "SSE problem. (#9304)",
            9305: "Invalid email. (#9305)",
            9306: "Insufficient instruments for sale. (#9306)",
            9307: "Insufficient funds for purchase. (#9307)",
            9308: "That email can't be used. (#9308)",
            9309: "Demo user blocked due to unconfirmed email. (#9309)",
            9310: "User already has an active session. (#9310)",
            9311: "No bank accounts found. (#9311)",
            9312: "You cannot create new demo account at this point. (#9312)",
            9401: "Invalid action. (#9401)",
            9402: "Invalid validity code. (#9402)",
            9403: "Invalid trading type. (#9403)",
            9404: "No such order. (#9404)",
            9405: "Invalid parameter. (#9405)",
            9406: "Invalid interval. (#9406)",
            9407: "Unrecognized instrument symbol. (#9407)",
            9408: "Incorrect dates. (#9408)",
            9409: "Index is not recognized. (#9409)",
            9410: "Too many parameters in request. (#9410)",
            9411: "Unrecognized exchange. (#9411)",
            9412: "Request error. (#9412)",
            9413: "Order conflicts with another active order. (#9413)",
            9414: "LEI identifier expired. (#9414)",
            9415: "Order cannot be executed outside exchange working hours. (#9415)",
            9416: "There was an error. Please log in again. (#9416)",
            default: "Unknown error.",
            nullOrUndefined: "Status not provided.",
        },
        bg: {
            9101: "Неразпознато действие. (#9101)",
            9102: "Неимплементирано действие. (#9102)",
            9103: "Грешка при изпълнение на командата. (#9103)",
            9104: "Неподдържана версия на софтуера. (#9104)",
            9105: "Грешка при изпълнение на заявката. (#9105)",
            9106: "Пазарната поръчка не трябва да съдържа цена. (#9106)",
            9201: "Неуспешна комуникация между модулите. (#9201)",
            9202: "Невалидна заявка или отговор от БД. (#9202)",
            9203: "Не може да се добави SSE събитие. (#9203)",
            9204: "Невалиден формат на датата. (#9204)",
            9205: "Неуспешно известие през Google API. (#9205)",
            9206: "Невалидно състояние на SSE параметъра. (#9206)",
            9207: "Грешка в локалната база данни. (#9207)",
            9208: "Сесията е изтекла. (#9208)",
            9209: "Ключът е изтекъл. (#9209)",
            9301: "Невалиден потребител или парола. Моля, провери идентификационните си данни. (#9301)",
            9302: "Няма такъв потребител. (#9302)",
            9303: "Неуспешна смяна на парола. (#9303)",
            9304: "Проблем със SSE. (#9304)",
            9305: "Невалиден имейл. (#9305)",
            9306: "Недостатъчно налични инструменти за продажба. (#9306)",
            9307: "Недостатъчно средства за покупка. (#9307)",
            9308: "Имейлът не може да се използва. (#9308)",
            9309: "Демо потребителят е блокиран поради непотвърден имейл. (#9309)",
            9310: "Потребителят вече има активна сесия. (#9310)",
            9311: "Не са намерени банкови сметки. (#9311)",
            9312: "Не може да бъде създаден нов демо акаунт. (#9312)",
            9401: "Невалидно действие. (#9401)",
            9402: "Невалиден код за валидност. (#9402)",
            9403: "Невалиден тип търговия. (#9403)",
            9404: "Няма такава поръчка. (#9404)",
            9405: "Невалиден параметър. (#9405)",
            9406: "Невалиден интервал. (#9406)",
            9407: "Неразпознат код на инструмента. (#9407)",
            9408: "Некоректни дати. (#9408)",
            9409: "Неразпознат индекс. (#9409)",
            9410: "Твърде много параметри в заявката. (#9410)",
            9411: "Неразпозната борса. (#9411)",
            9412: "Грешка при заявката. (#9412)",
            9413: "Поръчката е в конфликт с друга активна поръчка. (#9413)",
            9414: "LEI идентификаторът е изтекъл. (#9414)",
            9415: "Поръчката не може да се изпълни извън работното време на борсата. (#9415)",
            9416: "Възникна грешка. Моля, влез отново. (#9416)",
            default: "Обща грешка.",
            nullOrUndefined: "Статусът на командата не е получен.",
        }
    };

    const lang = language
        && typeof language === "string"
        && messages[language.toLowerCase()]
        ? language.toLowerCase()
        : "en";

    // 0 is OK, return empty string
    if (status === 0) {
        return "";
    }

    // null or undefined
    if (status == null) {
        return messages[lang].nullOrUndefined;
    }

    return messages[lang][status] || messages[lang].default;
}

export default {
    getStatusMessage: getStatusMessage
}
